import { bootstrapApplication } from "@angular/platform-browser";
import { importProvidersFrom, mergeApplicationConfig } from "@angular/core";
import { ModalModule } from "ngx-bootstrap/modal";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";

const browserConfig = mergeApplicationConfig(appConfig, {
  providers: [importProvidersFrom(ModalModule)],
});

bootstrapApplication(AppComponent, browserConfig).catch((err) =>
  console.error(err),
);
